export default {
      id: "next-usage",
      viewBox: "0 0 310 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#next",
      toString: function () {
        return this.url;
      }
    }